// "just now", "5 min ago", "3 h ago", "2 d ago", then a plain date. `ts` is unix seconds.
export function timeAgo(ts, nowMs = Date.now()) {
  const s = Math.max(0, Math.floor(nowMs / 1000) - ts);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  if (s < 86400 * 30) return `${Math.floor(s / 86400)} d ago`;
  return new Date(ts * 1000).toLocaleDateString();
}
